export class Pagination {
    CurrentPage: number;
    PerPage: number;
    TotalPages: number;
    TotalRecords: number;
}
